// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#docTemplateBlock{padding-left:1rem;padding-right:1rem;background:#fff}.spaIframe{width:100%;height:auto;border:none}.fading-container{opacity:1;transition:opacity 1s}.fading-container.fade{opacity:0}", ""]);
// Exports
module.exports = exports;
